var resourcesBaseURL = "https://s3.amazonaws.com/reup-app-builder-site-6/published_users/g72bu/reup-resources";// get from get params.
function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

var newResourceBaseURL = findGetParameter("resourcesDirectory");
if( newResourceBaseURL != null ) resourcesBaseURL = newResourceBaseURL;

module.exports = {
  absoluteFilesPrefix : resourcesBaseURL,
  filesPrefix : "",
  packagedResourcesDirectory : resourcesBaseURL,
  resourcesDirectory : resourcesBaseURL,
  oldResourcesDirectory : "",
  pendingResourcesDirectory : "",
  configFileName : resourcesBaseURL + "/ReUp-Config.plist",
  pendingConfigFileName : ""
}



// WEBPACK FOOTER //
// ./src/constants/PlatformConstants.js